<template>
	<div class='forgot-password'>

		<div class='container'>
      <h3>{{ $t('team.acceptInvitation') }} </h3>
      <br/>
      <h4 v-if='confirmed'>{{ $t('team.confirmed') }} <router-link :to='project.crowdfunding ? `/crowdfunding/${project.id}/${project.title}` : `/fundraising/${project.id}/${project.title}`'>{{ project.title }}</router-link></h4>
      <h4 v-else>{{ message }}</h4>
		</div>

    <crowd-or-rais></crowd-or-rais>
	</div>
</template>

<script>
// API
import teamApi from '@/api/v1/team';
// Components
import Alert from '@/components/Alert';
import CrowdOrRais from '@/components/CrowdOrRais';

export default {
  components: { Alert, CrowdOrRais },
  data() {
    return {
      message: '',
      project: '',
      confirmed: false,
    };
  },
  methods: {
    clearAlerts() {
      this.success = '';
      this.errors = {};
    },
  },
  created() {
    teamApi
      .acceptInvitation({ token: this.$route.query.token })
      .then((response) => {
        this.confirmed = true;
        this.message = response.data.message;
        this.project = response.data.project;
      })
      .catch((response) => {
        const data = response.response.data;
        this.message = data.errors ? data.errors[0] : data.message;
      });
  },
};
</script>



// WEBPACK FOOTER //
// AcceptTeamInvitation.vue?59d70d15